function ConditionalRender({
  children,
  condition,
}: {
  children: React.ReactNode;
  condition: boolean;
}) {
  return condition ? <>{children}</> : <></>;
}

export default ConditionalRender;
